export default __webpack_public_path__ + "static/media/attachment.e9e6ff80.svg";